var _excluded = ["to"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { Link as ReactLink } from "react-router-dom";
function isExternal(uri) {
  return uri.startsWith("http://") || uri.startsWith("https://");
}
function prepareUri(uri) {
  if (isExternal(uri)) {
    return uri;
  } else if (uri.startsWith("/")) {
    return uri;
  }
  return "/" + uri;
}

/**
 * Renders a regular link or router link depending on destination.
 *
 * @param {{ to: string }} props
 */
var Link = function Link(_ref) {
  var to = _ref.to,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return isExternal(to) ? /*#__PURE__*/React.createElement("a", _extends({
    href: to
  }, rest)) : /*#__PURE__*/React.createElement(ReactLink, _extends({
    to: prepareUri(to)
  }, rest));
};
export default Link;